import { render } from "./Source.vue?vue&type=template&id=fb63253e&scoped=true"
import script from "./Source.vue?vue&type=script&lang=js"
export * from "./Source.vue?vue&type=script&lang=js"

import "./Source.vue?vue&type=style&index=0&id=fb63253e&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb63253e"]])

export default __exports__